const CONSOLE_WORKSPACE_V2_KEY = 'metrly.preview.console_workspace_v2'

function parseBooleanFlag(value: string | null | undefined): boolean | null {
  if (!value) return null
  const normalized = value.trim().toLowerCase()
  if (['1', 'true', 'on', 'enabled'].includes(normalized)) return true
  if (['0', 'false', 'off', 'disabled'].includes(normalized)) return false
  return null
}

/**
 * Coordinated preview flag for the Console v2 shell and server workspace.
 *
 * Production builds require an explicit VITE_CONSOLE_WORKSPACE_V2 value or a
 * preview-session query parameter. Local Vite sessions default to the preview
 * so the integrated workspace can be reviewed without rebuilding the stack.
 */
export function isConsoleWorkspaceV2Enabled(): boolean {
  // A released workspace must not remain hidden by an old preview opt-out.
  if (parseBooleanFlag(import.meta.env.VITE_CONSOLE_WORKSPACE_V2) === true) return true

  if (typeof window !== 'undefined') {
    const requested = parseBooleanFlag(new URLSearchParams(window.location.search).get('console_workspace_v2'))
    if (requested !== null) {
      try { window.sessionStorage.setItem(CONSOLE_WORKSPACE_V2_KEY, String(requested)) } catch { /* storage is optional */ }
      return requested
    }

    try {
      const sessionValue = parseBooleanFlag(window.sessionStorage.getItem(CONSOLE_WORKSPACE_V2_KEY))
      if (sessionValue !== null) return sessionValue
    } catch { /* storage is optional */ }
  }

  return parseBooleanFlag(import.meta.env.VITE_CONSOLE_WORKSPACE_V2) ?? import.meta.env.DEV
}
